import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { todoSearch } from "../../redux/todos/Action";

const TodoSearch = () => {
  const value = useSelector((state) => state.todoReducer.todoSearch);
  const dispatch = useDispatch();

  return (
    <div className="bg-light p-4">
      <input
        type="text"
        className="form-control"
        placeholder="Search Tasks"
        onChange={(e) => dispatch(todoSearch(e.target.value))}
        defaultValue={value}
        style={{
          color: "white",
          backgroundColor: "rgb(33, 33, 33)",
          borderRadius: '4px'

        }}
      />
    </div>
  );
};

export default TodoSearch;
